// Font family constants
const fonts = {
  heading: "Noto Serif JP, serif",
  body: "Noto Serif JP, serif",
};

const fontSizes = {
  small: "12px",
  medium: "16px",
  large: "24px",
};

// Color palette
const colors = {
  text: {
    primary: "#FEFEFE",
    secondary: "#AAAAAA",
    warning: "red",
  },
  background: {
    card: "rgba(0, 0, 0, 0.3)",
    dialog: "#FEFEFE",
  },
};

const system = {
  fonts: fonts,
  fontSizes: fontSizes,
  colors: colors,
};
export default system;
